const i = {
  "mobile-navigation": "mobile-navigation",
  "mobile-navigation__overlay": "mobile-navigation__overlay",
  "mobile-navigation__overlay--open": "mobile-navigation__overlay--open",
  "mobile-navigation__overlay--closing": "mobile-navigation__overlay--closing",
  "mobile-navigation__header": "mobile-navigation__header",
  "mobile-navigation__close-button": "mobile-navigation__close-button",
  "mobile-navigation__list": "mobile-navigation__list",
  "mobile-navigation__list--primary": "mobile-navigation__list--primary",
  "mobile-navigation__meta-nav": "mobile-navigation__meta-nav"
};
export {
  i as default
};
